module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "app-root"
    }
  }, [(_vm.$root.IsLoading) ? _c('div', [_vm._m(0)]) : _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.$root.IsCarehomeUser) ? _c('div', [_c('menu-component')], 1) : _c('div', [_c('PharmacyNavMenu')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('router-view')], 1)])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: 'alt+/',
        title: 'Shortcut Help',
        description: 'Open shortcut help'
      }),
      expression: "{ keys:'alt+/', title:'Shortcut Help', description:'Open shortcut help'}"
    }],
    on: {
      "shortkey": _vm.OpenShortCutHelp
    }
  }), _vm._v(" "), _c('div', {
    ref: "shortcutModal",
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body "
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.shortcutData), function(sc) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('h4', [_vm._v(_vm._s(sc.title))]), _vm._v(" "), _c('table', {
      staticClass: "table table-striped"
    }, [_c('tbody', _vm._l((sc.commands), function(command) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "min-width": "50px"
        }
      }, [_vm._v(_vm._s(_vm.GetSequence(command.keySequence)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(command.description))])])
    }))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: ({
        keys: 'escape',
        title: 'Shortcut Help',
        description: 'Close Help'
      }),
      expression: "{keys:'escape', title: 'Shortcut Help', description:'Close Help'}"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "shortkey": _vm.CloseHelp
    }
  }, [_vm._v("Close")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('br'), _c('br'), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Shortcuts")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0ff94af4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ff94af4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/AppLoader/AppLoader.scp.html
// module id = 448
// module chunks = 0